export class IdentificationTypeConstant {
    public static GBR = 'VAT ID';
    public static IRL = 'VAT ID';
    public static ILN = 'VAT ID';
    public static USA = 'SSN';
    public static CAN = 'SIN';
    public static ARE = 'VAT ID';
    public static SAU = 'VAT ID';
    public static QAT = 'VAT ID';
    public static KWT = 'VAT ID';
    public static BHR = 'VAT ID';
    public static OMN = 'VAT ID';
    public static AUS = 'VAT ID';
    public static SWE = 'SSN';
    public static NOR = 'SSN';
    public static FIN = 'SSN';
    public static DNK = 'SSN';
    public static NZL = 'VAT ID';
    public static POL = 'PERSONAL ID';
    public static DEU = 'SSN';
    public static AUT = 'SSN';
    public static MKD = 'PERSONAL ID';
    public static BGR = 'PERSONAL ID';
    public static NLD = 'BSN';
    public static ISL = 'KT';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/identification-type.constant.ts